import * as v from 'valibot';

const PersonStatus = v.union([
  v.literal('offline'),
  v.literal('idle'),
  v.literal('online'),
]);

export const CommonProfileField = v.object({
  label: v.string(),
  value: v.nullable(v.string()),
  id: v.string(),
});

export const PersonDataSchema = v.object({
  roleWeight: v.nullish(v.number()),
  roles: v.nullish(v.array(v.string())),
  status: PersonStatus,
  userId: v.number(),
  facebookUrl: v.nullable(v.string()),
  email: v.nullable(v.string()),
  thumbnail: v.string(),
  firstName: v.nullable(v.string()),
  lastName: v.nullable(v.string()),
  customFields: v.array(CommonProfileField),
  linkedInUrl: v.nullable(v.string()),
  googleUrl: v.nullable(v.string()),
  displayName: v.nullable(v.string()),
});

export type TCommonProfile = v.Output<typeof CommonProfileField>;
export type TPersonData = v.Output<typeof PersonDataSchema>;
